import toastr from 'toastr';
import {getCurrentUserId, getJwt} from '../../services/authService';
import http from '../../services/httpService';

export const FileUploadVaporNaked = async (file, onUploadStart, onUploadProgressChange, onUploadEnd, onUploadError, isWebpush) => {
    let vaporStore = async (file, options = {}) => {
        /**
         * Store a file in S3 and return its UUID, key, and other information.
         */
        // console.log('vaporStore entered')
        /* Getting signed storage url that will be used for uploading file */
        try{
            const response = await http.post(options.signedStorageUrl ? options.signedStorageUrl : '/vapor/signed-storage-url', {
                'bucket': options.bucket || '',
                'content_type': options.contentType || file.type,
                'expires': options.expires || '',
                'visibility': options.visibility || ''
            }, {
                baseURL: options.baseURL || null,
                headers: options.headers || {},
                ...options.options
            });
            let headers = response.data.headers;
            if ('Host' in headers) {
                delete headers.Host;
            }
            if (typeof options.progress === 'undefined') {
                options.progress = () => {
                };
            }
            const cancelToken = options.cancelToken || ''
            // console.log('file for Vapor: ', file)
            /* Uploading file to Vapor */
            try{
                await http.put(response.data.url, file.file, {
                    cancelToken: cancelToken,
                    headers: headers,
                    onUploadProgress: (progressEvent) => {
                        options.progress(progressEvent.loaded / progressEvent.total);
                        onUploadProgressChange(progressEvent.loaded / progressEvent.total)
                        // console.log('progressEvent for put: ', progressEvent)
                    }
                })
                // response.data.extension = await file.name.split('.').pop();
                // console.log('response.data.extension: ', response.data.extension)
                return response.data;
            }catch{
                onUploadError();
                toastr.error('File upload failed, please try again.')
            }
        }catch{
            onUploadError();
            toastr.error('File Upload Vapor error, please try again.')
        }
    }
    let response = await vaporStore(file, {
        signedStorageUrl: process.env.REACT_APP_ENVIRONMENT === 'DEV' ?
            'https://dev-api.emitto.io/vapor/signed-storage-url' : 'https://api.emitto.io/vapor/signed-storage-url',
        // bucket: process.env.REACT_APP_AWS_BUCKET,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            // 'X-CSRF-TOKEN': 'E2qbbo6ul8EW0TT23CBAMXhJAVWYuhvhSTYI3YJr',
            'X-Requested-With': 'XMLHttpRequest',
            // 'X-CSRF-Token': csrfToken.toString(),
            authorization: getJwt()
        },
        visibility: 'public-read',
        // progress: progress => {
        //     console.log('progress: ', progress)
        //     this.uploadProgress = Math.round(progress * 100);
        // }
    })
    // console.log('vaporStore response: ', response)
    if(response && response.key){
        try {
            onUploadStart();
            let userId = getCurrentUserId()
            // console.log('jwt: ', getJwt())
            if (!isWebpush) {
                // console.log('upload userId: ', userId)
                // console.log('response.key: ', response.key)
                let result = await http.post('/api/files/' + userId, {
                    category: file.category ? file.category : 'images',
                    // uuid: response.uuid,
                    key: response.key,
                    // bucket: response.bucket,
                    name: file.name,
                    // content_type: acceptedFiles[0].type,
                }, {headers: {authorization: getJwt()}});
                onUploadEnd(result.data[file.category], file)
                // this.setState({uploading: false, progress: 0})
                toastr.success("File successfully uploaded!");
            } else {
                // console.log('upload userId: ', userId)
                // console.log('response.key: ', response.key)
                // console.log('webpush script upload started')
                let result = await http.post('/api/files_scr', {
                    user_id: userId,
                    category: file.category ? file.category : 'images',
                    // uuid: response.uuid,
                    key: response.key,
                    // bucket: response.bucket,
                    name: file.name,
                    // content_type: acceptedFiles[0].type,
                }, {headers: {authorization: getJwt()}});
                onUploadEnd(result)
                // this.setState({uploading: false, progress: 0})
                toastr.success("File successfully uploaded!");
            }
        } catch (error) {
            toastr.error('Upload error: ', error)
            // console.error('Upload error:', error);
        }
    }
}